import omit from 'lodash/omit';
import get from 'lodash/get';
import keys from 'lodash/keys';
import flow from 'lodash/flow';
import { omitKeys } from './constants';

const filterKeys = (item) => omit(item, omitKeys);
const getFilteredKeys = (item) => flow([filterKeys, keys])(item);

const getTranslatedColumnLabel = (columnName) => {
  switch (columnName) {
    case 'name':
      return 'services:categories.table.headers.name';
    case 'description':
      return 'services:categories.table.headers.description';
    default:
      return columnName;
  }
};

export const mapTableHeaderColumns = (tableData) => {
  const getFirstItem = (items) => get(items, '[0]', {});
  const rawColumns = flow([getFirstItem, getFilteredKeys])(tableData);

  // Return translation keys for the columns
  return rawColumns.map((columnKey) => ({
    key: columnKey,
    label: getTranslatedColumnLabel(columnKey),
  }));
};

export const mapTableColumns = (item) => getFilteredKeys(item);
